// 3rd party
import * as React from 'react';

// Shared UI
// import { LocalizedText } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkIcon } from 'uitk-react-icons';
import { UitkLink } from 'uitk-react-link';

// Models
import { Product } from 'models';

interface WidgetCodeGuideLinkProps {
  product: Product;
}

const WidgetCodeGuideLink = React.memo(
  // tslint:disable-next-line:no-shadowed-variable
  function WidgetCodeGuideLink(props: WidgetCodeGuideLinkProps): JSX.Element {
    const { product } = props;

    return (
      // <UitkLink inline={true} analytics={trackImplementationGuideLink}>
      <UitkLink inline={true}>
        <a href={product.guideLink} target="_blank" rel="noreferrer">
          {/*<LocalizedText message="product.widget.code.implementation_guide" />*/}
          {'Implementation Guide'}
          <UitkIcon name="open_in_new" />
        </a>
      </UitkLink>
    );
  },
);

export { WidgetCodeGuideLink };
